import { createFileRoute, Navigate } from "@tanstack/react-router"
import { CropPage } from "@/features/project-editor/upload-flow/cropRoute"
import { usePermissions } from "@/hooks/usePermissions"

export const Route = createFileRoute("/(authenticated)/projects/new/$projectId/crop")({
  component: CropRouteComponent,
})

function CropRouteComponent() {
  const { projectId } = Route.useParams()

  // Access control: Only users with project:update permission can crop
  const { hasPermission, isLoading } = usePermissions()

  // Wait for permissions to load before checking access
  if (isLoading) {
    return null
  }

  const canCrop = hasPermission("project", "update").allowed

  if (!canCrop) {
    return <Navigate to="/projects" />
  }

  return <CropPage projectId={projectId} />
}
